<div class="At-SettingPage">
  <div class="At-PageHeading">
    <h2>settings</h2>
    <div class="At-RightBox">
      <div class="At-BtnArea">
        <button type="button" class="mr-4">save changes</button>
        <button type="button" class="At-BgGrey">reset all</button>
      </div>
    </div>
  </div>
  <div class="At-SettingContentArea">
      <aside class="At-TabsSideBar">
        <ul>
          <li><button type="button" class="At-TabsBtn active" (click)="selectTab(0)" (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}"><i class="icon-notification"></i>notifications</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(1)" (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}"><i class="icon-lock"></i>privacy</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(2)" (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}"><i class="icon-language"></i>language</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(3)" (click)="onClick(4)" [ngClass]="{'active': tab==='tab4'}"><i class="icon-question-mark"></i>help</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(4)" (click)="onClick(5)" [ngClass]="{'active': tab==='tab5'}"><i class="icon-bage"></i>upgrade to vip subscription</button></li>
          <li>
            <div class="At-SwitchCustom">
              <span class="At-SwitchText">Switch to Dark Mode</span>
              <label class="switch">
                <!-- <input type="checkbox" id="customSwitch1"  class="my_class" (click)="clickEvent()" [ngClass]="status ? 'success' : 'danger'"> -->
                <input type="checkbox" id="customSwitch1"  class="my_class" (click)="changeMode()" [checked]="darkMode">
                <span class="slider round"></span>
              </label>
              <!-- Selected: {{status}} -->
            </div>
          </li>
        </ul>
      </aside>
      <div class="At-TabContent">
        <tabset #staticTabs>
          <tab heading="0">
            <app-notifications-settings></app-notifications-settings>
          </tab>
          <tab heading="1">
            <app-privacy></app-privacy>
          </tab>
          <tab heading="2">
            <app-language></app-language>
          </tab>
          <tab heading="3">
            <app-help></app-help>
          </tab>
          <tab heading="4">
            <app-upgrade-subcription></app-upgrade-subcription>
          </tab>
        </tabset>
      </div>
  </div>
</div>
